const initialState = {
  loading: false,
  isAuthenticated: !!localStorage.getItem('clientToken'),
  client: JSON.parse(localStorage.getItem('clientData') || 'null'),
  token: localStorage.getItem('clientToken') || null,
  points: parseInt(localStorage.getItem('clientPoints')) || 0,
  history: [], // Added history
  error: null,
  message: null
};

export default function clientReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'CLIENT_LOGIN_REQUEST':
    case 'CLIENT_REGISTER_REQUEST':
    case 'GET_HISTORY_REQUEST': // Added
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'CLIENT_LOGIN_SUCCESS':
    case 'CLIENT_REGISTER_SUCCESS':
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        client: payload.client,
        token: payload.token,
        points: payload.client.points || 0,
        error: null
      };

    case 'CLIENT_LOAD_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        client: payload,
        points: payload.points || 0,
        loading: false,
        error: null
      };

    case 'CLIENT_LOGIN_FAIL':
    case 'CLIENT_REGISTER_FAIL':
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        client: null,
        token: null,
        points: 0,
        error: payload,
        message: null
      };

    case 'CLIENT_LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        client: null,
        token: null,
        points: 0,
        history: [], // Clear history
        error: null,
        message: null
      };

    case 'UPDATE_POINTS':
      return {
        ...state,
        points: payload
      };

    case 'GET_HISTORY_SUCCESS': // Added
      return {
        ...state,
        loading: false,
        history: payload,
        error: null
      };

    case 'GET_HISTORY_FAIL': // Added
      return {
        ...state,
        loading: false,
        error: payload
      };

    case 'SET_MESSAGE':
      return {
        ...state,
        message: payload
      };

    case 'CLEAR_MESSAGE':
      return {
        ...state,
        message: null
      };

    case 'UPDATE_CLIENT_PROFILE':
      return {
        ...state,
        client: payload,
        loading: false,
        error: null
      };

    default:
      return state;
  }
}